import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import type { IQuestionData } from 'models/question.model'
import SurveyQuestionsEditor, {
  SurveyQuestionsEditorHandle,
} from '../survey-questions/components/survey-questions-editor/SurveyQuestionsEditor'

interface IProps {
  title: string
  index: number
  data?: IQuestionData
  blockId?: number
  onSave: (data: unknown, type: string) => void
  onClose: () => void
}

/** Question form in the same modal the question bank uses to add or edit. */
export const SurveyQuestionModal = ({
  title,
  index,
  data,
  blockId,
  onSave,
  onClose,
}: IProps) => {
  const { t } = useTranslation()
  const editorRef = useRef<SurveyQuestionsEditorHandle>(null)
  const prefix = 'administration.surveyEditor.buttons'

  return (
    <Modal
      title={title}
      close={onClose}
      maxwidth={800}
      maxheight={720}
      actions={
        <ModalButtons
          secondaryText={t(`${prefix}.discard`)}
          secondaryAction={onClose}
          primaryText={t(`${prefix}.save`)}
          primaryAction={() => editorRef.current?.save()}
        />
      }
    >
      <SurveyQuestionsEditor
        ref={editorRef}
        index={index}
        data={data}
        blockId={blockId}
        onSave={onSave}
      />
    </Modal>
  )
}
